/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import FormLayout from "../components/layout/form"
// import { isEmpty, isNil } from "lodash";
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { useEffect, useState } from "react";
import { FRStep } from "@forgerock/javascript-sdk";
import invStyles from '../styles/inviteUsers.module.css';


interface Props {
    header: string,
    description?:string
    nextStepMessage?:string
    button?:JSX.Element
    step: FRStep,
  }
  export default function InviteSuccessPage ({step,header,description,nextStepMessage,button=<></>}: Props) {

    const [inviteResults,setInviteResults] = useState<any>();

    useEffect( ()=>{
      step.callbacks.forEach((callback, i) => {
        console.log("Step being used :  " , JSON.parse(callback.getOutputValue('message') as string))
        let inviteValues = JSON.parse(callback.getOutputValue('message') as string)
        setInviteResults(inviteValues);
        // console.log(inviteValues['User Skipped'])
      })
      } ,[])


    const inviteStatusRecords = () => {
      let uiElement: JSX.Element = <></>;
      let children: JSX.Element[] = [];
      // console.log("inviteResults",inviteResults.userSkipped);
      if (!!inviteResults){
        for (const key in inviteResults) {
          if (inviteResults.hasOwnProperty(key)) {
            
            if (key === 'userInvited' && !isEmpty(inviteResults[key]) ){
              let usersList = inviteResults[key].split(',')
              usersList.forEach((value:string)=>{
                children.push(<>
                  <div className={invStyles.inviteStatusInternal}>
                    <div className={invStyles.inviteStatus}>User Invited</div>
                    <div className={invStyles.rolevalue}>{value}</div>
                  </div>
              </>)
              })
              usersList = null;
          }
            if (key === 'userAdded' && !isEmpty(inviteResults[key])){
              let usersList = inviteResults[key].split(',')
              usersList.forEach((value:string)=>{
                children.push(<>
                  <div className={invStyles.inviteStatusInternal}>
                    <div className={invStyles.inviteStatus}>User Added</div>
                    <div className={invStyles.rolevalue}>{value}</div>
                  </div>
              </>)
              })
              
            }
            if (key === 'userSkipped' && !isEmpty(inviteResults[key])){
              let usersList = inviteResults[key].split(',')
              usersList.forEach((value:string)=>{
                children.push(<>
                  <div className={invStyles.inviteStatusInternal}>
                    <div className={invStyles.inviteStatus}>User Skipped</div>
                    <div className={invStyles.rolevalue}>{value}</div>
                  </div>
              </>)
              })
            }
          }
        }
      }

      uiElement = <div>{children}</div>
      return uiElement;

      // userInvited 
// InviteSuccessPage.tsx:41 userAdded 
// InviteSuccessPage.tsx:41 userSkipped test@test.com
// form.tsx:28 

      // let usersArray = commaSeperatedtoArray(inviteResults.userSkipped)
    }

    const getInvitedUsers = (Results:{}) => {

      let uiElement: JSX.Element = <></>;
      let children: JSX.Element[] = [];

      children.push(
        <div className={invStyles.content}>
          <div className={invStyles.sideHeaderContainer}>
            <div
              className={invStyles.sideheader1}
              dangerouslySetInnerHTML={{ __html: "Status " }}
            ></div>
            <div
              className={invStyles.sideheader2}
              dangerouslySetInnerHTML={{ __html: "USER EMAIL " }}
            ></div>
          </div>
          <div className={invStyles.inviteUserResults}>
            {inviteStatusRecords()}
          </div>
        </div>
      );

      uiElement = <div>{children}</div>
      return uiElement;
    }
  
    return (
      <FormLayout
        header={header}
        subHeader={description}
        button={button}>
        {getInvitedUsers(inviteResults)}
  
      </FormLayout>
    );
  };